export default {
  lucky: {
    prizeAgain: 'Free Spin',
    prizeThanks: 'Better Luck Next Time',
    remainingChance: 'Remaining Spins',
    task: 'Task',
    deposit: 'Deposit',
    wager: 'Wager',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Card Collection',
    puzzleRound: 'Round {current}/{total}',
    puzzleReward: 'Complete reward {amount}',
    redeem: 'Redeem',
    redeemSuccess: 'Redeemed successfully',
    redeemSuccessWithReward: 'Redeemed successfully! You got {amount} {currency}',
    redeemFailed: 'Redeem failed',
    notComplete: 'Not complete yet, cannot redeem',
    drawFailed: 'Draw failed, please try again',
    gainLetter: 'Congratulations! You got the letter {letter}',
    gainBlock: 'Congratulations! You got picture {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Invite',
    claimReward: 'Claim',
    noChest: 'No Chest',
    claimSuccess: 'Claimed {count} chests, {amount} {currency}',
    claimFailed: 'Claim failed, please try again',
    modalTitle: 'Treasure Chest',
    modalSubtitle: 'Swipe left or right to view all',
    chipTodayClaimed: 'Claimed Today',
    chipClaimable: 'Claimable',
    chipLocked: 'Locked',
    totalClaimedCount: 'Total Chests Claimed',
    totalClaimedAmount: 'Total Amount Claimed',
    chestUnit: 'pcs',
    claimAll: 'Claim All',
    goInvite: 'Go Invite',
    claimSingleSuccess: 'Claimed {amount} {currency}',
    labelClaimed: 'Claimed',
    labelClaimable: 'Claimable',
    labelLocked: 'Locked',
  },
}
